// extracted by mini-css-extract-plugin
export default {"file-settings":"FileSettings_file-settings__eGE1z","file-settings__input":"FileSettings_file-settings__input__KiUn3"};